/* eslint-disable no-unused-vars */
import Vue from "vue";

export default {
	state: {},
	mutations: {},
	actions: {
		getSaneamentoRequirements() {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("saneamentoLoad/requirements")
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},

		downloadSaneamentoTemplate(_, { idRequirement, key, description }) {
			this.state.loading = true;

			const params = new URLSearchParams();
			if (idRequirement != null) params.append("idRequirement", idRequirement);
			if (key) params.append("key", key);
			const queryString = params.toString();
			const url = "saneamentoLoad/template" + (queryString ? `?${queryString}` : "");

			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.download(url)
					.then((response) => {
						this.state.loading = false;

						const blob = new Blob([response.data], {
							type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
						});
						const fileURL = window.URL.createObjectURL(blob);

						let fileName = null;

						if (description && description.trim().length > 0) {
							fileName = `${description.trim()}.xlsx`;
						} else {
							const contentDisposition = response.headers["content-disposition"];
							if (contentDisposition) {
								const utf8Match = /filename\*\s*=\s*(?:UTF-8|utf-8)''([^;]+)/i.exec(contentDisposition);
								if (utf8Match && utf8Match[1]) {
									try {
										fileName = decodeURIComponent(utf8Match[1].trim().replace(/^"|"$/g, ""));
									} catch (e) {
										// se decodeURIComponent falhar, segue pro próximo fallback
									}
								}
								if (!fileName) {
									const asciiMatch = /filename\s*=\s*"?([^";]+)"?/i.exec(contentDisposition);
									if (asciiMatch && asciiMatch[1]) {
										fileName = asciiMatch[1].trim().replace(/^"|"$/g, "");
									}
								}
							}
							if (!fileName) fileName = "Saneamento.xlsx";
						}

						const fURL = document.createElement("a");
						fURL.href = fileURL;
						fURL.setAttribute("download", fileName);
						document.body.appendChild(fURL);
						fURL.click();
						document.body.removeChild(fURL);
						window.URL.revokeObjectURL(fileURL);
						resolve();
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},

		uploadSaneamentoFile(_, { file, idRequirement, key }) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				const formData = new FormData();
				formData.append("file", file);
				if (idRequirement != null) formData.append("idRequirement", idRequirement);
				if (key) formData.append("key", key);

				Vue.prototype.$http
					.post("saneamentoLoad/upload", formData)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},

		getSaneamentoHistory(_, filter) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("saneamentoLoad/history", filter ?? {})
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},

		downloadSaneamentoUploadedFile(_, { idSaneamentoLoad, fileName }) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.download(`saneamentoLoad/file/${idSaneamentoLoad}`)
					.then((response) => {
						this.state.loading = false;

						const blob = new Blob([response.data], {
							type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
						});
						const fileURL = window.URL.createObjectURL(blob);

						let downloadName = fileName || `saneamento_${idSaneamentoLoad}.xlsx`;
						const contentDisposition = response.headers["content-disposition"];
						if (contentDisposition) {
							const utf8Match = /filename\*\s*=\s*(?:UTF-8|utf-8)''([^;]+)/i.exec(contentDisposition);
							if (utf8Match && utf8Match[1]) {
								try {
									downloadName = decodeURIComponent(utf8Match[1].trim().replace(/^"|"$/g, ""));
								} catch (e) {
									// ignora — usa fallback
								}
							}
						}

						const fURL = document.createElement("a");
						fURL.href = fileURL;
						fURL.setAttribute("download", downloadName);
						document.body.appendChild(fURL);
						fURL.click();
						document.body.removeChild(fURL);
						window.URL.revokeObjectURL(fileURL);
						resolve();
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},

		getSaneamentoErrors(_, idSaneamentoLoad) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get(`saneamentoLoad/errors/${idSaneamentoLoad}`)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		}
	},
	getters: {}
};
